import { useContext } from 'react';
import { BlogContext } from '../losse/LosseBlogBink';
/**
 * Get blog model state and functions.
 */
export default function useLosseBlogBink() {
    const context = useContext(BlogContext);
    return context;
}
